import ChartDescription from './chart-description';
export default ChartDescription;